module.exports = __webpack_public_path__ + "static/media/eltcloud.e5429fa7.svg";